import type { RootState } from '@shared/stores/rootTypes';

const layoutSelector = (state: RootState) => state.layout;

export { layoutSelector };
